import { piiFormModel } from 'components/FormFields/PII';

const { addressModel } = piiFormModel;

export default addressModel;
